module.exports = __webpack_public_path__ + "img/icon-arrow-down.3bbae039.svg";